function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8 4h1.5v16H8zM14.5 4H16v16h-1.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 8v1.5H4V8zM20 14.5V16H4v-1.5z"
});

function SvgNumberIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgNumberIcon;